module.exports = __webpack_public_path__ + "img/p_3.01a1e455.png";